import { HTMLAttributes } from 'react';

import { cn } from '@/components/ui';

export const ImageError = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => (
  <div aria-label="Image unavailable" role="img" className={cn('bg-line', className)} {...props} />
);
